<script setup lang="ts">
import LinkIcon from '../icons/LinkIcon.vue';
import { showNotification } from '../../notifications/notification_actions';
import { isSmartphone } from '../../../constants/ui';

function copy() {
  const path = window.location.href;
  window.navigator.clipboard.writeText(path);

  showNotification('any_type', {
    data: path,
    emoji: '👌',
    title: isSmartphone.value ? 'Link copied to clipboard' : 'Link has been successfully copied to clipboard',
  });
}
</script>

<template>
  <svg width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg" class="hidden laptop:inline">
    <path
      class="fill-gray-400 dark:fill-gray-500"
      d="M5.236 6.012L4.564 5.34L5.768 4.136L6.468 3.548L6.454 3.506L5.11 3.59H0.406V2.638H5.11L6.454 2.722L6.468 2.68L5.768 2.092L4.564 0.888L5.236 0.215999L8.134 3.114L5.236 6.012Z"
    />
  </svg>

  <button class="ml-s flex items-center gap-xs text-brand-cta" @click="() => copy()">
    <LinkIcon class="stroke-brand-cta" />
    <span class="hidden text-[14px] laptop:inline">Copy shared link</span>
  </button>
</template>
